import React from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import SingleIcon from '../../assets/single_charge.svg';
// import RecurringIcon from '../../assets/recurring_charge.svg';
import Button from '@sendsprint/ui-react/dist/components/Button';
import useMedia from '@src/hooks/utils/useMedia';
import PaymentTypeItem from './paymentTypeItem';

interface Props {
  selectedItemId: string | null;
  handleSelectItemId: (arg: string) => void;
  handleAddOpen: () => void;
}

const SelectPaymentType = ({ selectedItemId, handleSelectItemId, handleAddOpen }: Props) => {
  const { isMobile } = useMedia();

  return (
    <>
      <Box className="ss-bg-white ss-space-y-3 ss-p-4 ss-rounded-lg ss-mb-5">
        <p className="ss-text-neutral-400 ss-text-sm">Select a payment link type to continue</p>
      </Box>
      <Box>
        <Box className="ss-space-y-8 ss-mb-18">
          <PaymentTypeItem
            icon={SingleIcon}
            description="Generate a payment link to collect a one-time payment from your customer."
            handleSelectItem={() => handleSelectItemId('1')}
            header="Single charge"
            isSelected={selectedItemId === '1'}
          />
          {/* <PaymentTypeItem
            icon={RecurringIcon}
            description="Set up recurring payments or payment plans, create a link tailored to your customers."
            handleSelectItem={() => handleSelectItemId('2')}
            header="Recurring charge"
            isSelected={selectedItemId === '2'}
          /> */}
        </Box>
        <Box className="ss-text-center">
          <Button
            onClick={handleAddOpen}
            variant={isMobile ? 'tertiary' : 'primary'}
            label={'Create payment link'}
            className="ss-w-full ss-rounded-[20px]"
            disabled={!selectedItemId}
          />
        </Box>
      </Box>
    </>
  );
};

export default SelectPaymentType;
